export const services = [
  {
    id: 1,
    icon: "code",
    title: "Custom Web Application Development",
    description:
      "End-to-end development of tailored web applications using PHP, Laravel, and modern JavaScript frameworks — built for scale, speed, and business impact.",
  },
  {
    id: 2,
    icon: "wordpress",
    title: "WordPress Development & Plugin Customization",
    description:
      "Custom themes, plugins, WooCommerce stores, and platform migrations — delivering pixel-perfect, high-performance WordPress solutions.",
  },
  {
    id: 3,
    icon: "server",
    title: "Laravel Backend Development",
    description:
      "Robust, secure backend systems with Laravel — including APIs, admin panels, authentication, and database architecture.",
  },
  {
    id: 4,
    icon: "api",
    title: "API Integration & Automation",
    description:
      "Seamless integration of third-party APIs, payment gateways, AI services, and automation workflows to streamline business operations.",
  },
  {
    id: 5,
    icon: "speed",
    title: "Website Performance Optimization",
    description:
      "Comprehensive performance audits and optimization — reducing load times by 30–40% and achieving 90+ Lighthouse scores.",
  },
  {
    id: 6,
    icon: "seo",
    title: "SEO & Core Web Vitals Improvement",
    description:
      "Technical SEO implementation, Core Web Vitals optimization, schema markup, and search ranking improvements for measurable organic growth.",
  },
  {
    id: 7,
    icon: "cloud",
    title: "Cloud Deployment & Hosting Setup",
    description:
      "AWS deployment (EC2, S3), server configuration, SSL setup, domain management, and reliable hosting architecture.",
  },
];
